// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cards-container{
    margin-top: 20px;
    
}
.card-body{
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
    justify-items: center;
    text-align: center;

    /* @media(max-width:1370px){
        grid-template-columns: repeat(4, 1fr);
    }
    @media(max-width:790px){
        grid-template-columns: repeat(2, 1fr);
    }
    @media(max-width:370px){
        grid-template-columns: repeat(1, 1fr);
    } */


      :hover{
        transform: scale(1.01);
        cursor: pointer;
    }
    
}
.cardItem{
    box-shadow: 2px 5px 5px rgba(86, 86, 86, 0.463);
    background: rgb(255, 255, 255);
    padding: 20px;
    border-radius: 12px;
    width: 100%;
    box-sizing: border-box;

    :hover{
        transform: scale(1.02);
    }
}

.tableHead th{
    background: #c25a1ede !important;
    color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/cards.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;;AAEpB;AACA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,qBAAqB;IACrB,kBAAkB;;IAElB;;;;;;;;OAQG;;;MAGD;QACE,sBAAsB;QACtB,eAAe;IACnB;;AAEJ;AACA;IACI,+CAA+C;IAC/C,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;;IAEtB;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;AAC3B","sourcesContent":[".cards-container{\r\n    margin-top: 20px;\r\n    \r\n}\r\n.card-body{\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\r\n    gap: 20px;\r\n    justify-items: center;\r\n    text-align: center;\r\n\r\n    /* @media(max-width:1370px){\r\n        grid-template-columns: repeat(4, 1fr);\r\n    }\r\n    @media(max-width:790px){\r\n        grid-template-columns: repeat(2, 1fr);\r\n    }\r\n    @media(max-width:370px){\r\n        grid-template-columns: repeat(1, 1fr);\r\n    } */\r\n\r\n\r\n      :hover{\r\n        transform: scale(1.01);\r\n        cursor: pointer;\r\n    }\r\n    \r\n}\r\n.cardItem{\r\n    box-shadow: 2px 5px 5px rgba(86, 86, 86, 0.463);\r\n    background: rgb(255, 255, 255);\r\n    padding: 20px;\r\n    border-radius: 12px;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n\r\n    :hover{\r\n        transform: scale(1.02);\r\n    }\r\n}\r\n\r\n.tableHead th{\r\n    background: #c25a1ede !important;\r\n    color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
